<script>
    import Home from './Home.svelte';
    import Contact from './Contact.svelte';
    import Leadership from './Leadership.svelte';
    import Projects from './Projects.svelte';
    import Icons from './Icons.svelte';
    import Enlighten from './Enlighten.svelte';

   
    let currentYear = new Date().getFullYear();
    
    // References for scrolling
    let homeRef;
    let projectsRef;
    let contactRef;
    let enlightenRef;

    function navigate(ref) {
        if (ref) {
            ref.scrollIntoView({ behavior: 'smooth' }); // Scroll to the referenced element
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
    
    @keyframes slideInRight {
        0% {
            transform: translateX(200%);
            opacity: 0;
        }
        100% {
            transform: translateX(0);
            opacity: 1;
        }
    }

    @keyframes slideInLeft {
        0% {
            transform: translateX(-200%);
            opacity: 0;
        }
        100% {
            transform: translateX(0);
            opacity: 1;
        }
    }
	
    :global(body) {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        margin: 0;
        background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        color: #ffffff;
        line-height: 1.6;
    }

    :global(*) {
        box-sizing: border-box;
    }

    nav {
        position: sticky;
        top: 0;
        z-index: 100;
        background: rgba(15, 15, 35, 0.95);
        backdrop-filter: blur(10px);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        padding: 1rem 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0;
    }

    .nav-container {
        display: flex;
        gap: 2rem;
        align-items: center;
    }

    .content {
        margin-top: 0;
        padding: 0 2rem;
    }

    footer {
        margin-top: 2rem;
        text-align: center;
        padding: 2rem;
        background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
        border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    footer a {
        color: #64b5f6;
        margin: 0 1rem;
        text-decoration: none;
        font-weight: 500;
        transition: color 0.3s ease;
    }

    footer a:hover {
        color: #90caf9;
    }

    .icon, .icon-terplink {
        width: 32px;
        height: 32px;
        object-fit: contain;
        transition: transform 0.3s ease;
    }

    .icon:hover, .icon-terplink:hover {
        transform: scale(1.1);
    }

    .button {
        animation: slideInRight 1.5s ease forwards;
        cursor: pointer;
        text-decoration: none;
        color: #ffffff;
        background: none;
        border: none;
        font-size: 1.1rem;
        font-weight: 500;
        outline: none;
        font-family: 'Inter', sans-serif;
        padding: 0.75rem 1.5rem;
        border-radius: 8px;
        transition: all 0.3s ease;
        position: relative;
    }

    .button:hover {
        background: rgba(255, 255, 255, 0.1);
        transform: translateY(-2px);
    }

    .button:focus {
        background: none;
        outline: 2px solid #64b5f6;
        outline-offset: 2px;
    }

    .content {
        flex: 1;
        max-width: 1200px;
        margin: 0 auto;
        width: 100%;
    }

    @media only screen and (max-width: 768px) {
        .content {
            padding: 0 1rem;
        }
        
        nav {
            padding: 1rem;
        }
        
        .nav-container {
            gap: 1rem;
        }
        
        .button {
            font-size: 1rem;
            padding: 0.5rem 1rem;
        }
    }
</style>

<nav>
    <div class="nav-container">
        <button class="button" on:click={() => navigate(homeRef)}>About</button>
        <button class="button" on:click={() => navigate(projectsRef)}>Projects</button>
        <button class="button" on:click={() => navigate(enlightenRef)}>Scripts</button>
        <button class="button" on:click={() => navigate(contactRef)}>Contact</button>
    </div>
</nav>

<div class="content">
    <div bind:this={homeRef}><Home /></div>
    <Icons  onClick={() => navigate(contactRef)}/>
    <Leadership/>
    <div bind:this={projectsRef}><Projects/></div>
    <div bind:this={enlightenRef}><Enlighten/></div>
    <div bind:this={contactRef}><Contact/></div>
</div>

<footer>
    <p>&copy; {currentYear} Joshua Zheng. All rights reserved.</p>
    <div style="margin-top: 1rem;">
        <a href="https://github.com/JoshuaZheng0/" target="_blank" class="icon-container">
            <img src="/assets/icons/github-mark-white.svg" alt="GitHub Icon" class="icon" />
        </a>
        <a href="https://www.linkedin.com/in/joshzheng7/" target="_blank" class="icon-container">
            <img src="/assets/icons/linkedin-icon-white.svg" alt="LinkedIn Icon" class="icon" />
        </a>
        <a on:click={() => navigate(contactRef)} class="icon-container">
            <img src="/assets/icons/email.png" alt="Email Icon" class="icon-terplink" />
        </a>
    </div>
</footer>


